(() => {
  'use strict';
  const limits = {'20-oz-powder-coated-tumblers':12,'metal-pens':10,'custom-bottle-opener-keychains':50};
  const quoteUrl = (item, quantity) => {
    const url = new URL('/pages/contact', location.origin);
    const options = item.options_with_values || [];
    url.search = new URLSearchParams({project:'bulk',source:'cart',product:item.product_title || item.title,quantity:String(quantity),customization:options[1]?.value || '',color:options[2]?.value || '',engraving:item.properties?.['Engraving Text'] || item.properties?.['Engraving text'] || ''});
    return url.href;
  };
  const readCart = async () => {
    const response = await fetch((window.Shopify?.routes?.root || '/')+'cart.js',{headers:{Accept:'application/json'}});
    if(!response.ok) throw Error('Cart could not be checked. Please refresh and try again.');
    return response.json();
  };
  const bulkItem = cart => {
    // Include visible edits while the theme's debounced cart update is pending.
    document.querySelectorAll('input[name="updates[]"][data-index]').forEach(input=>{
      const item=cart.items[Number(input.dataset.index)-1];
      const pending=Number(input.value);
      if(item && Number.isFinite(pending))item.quantity=Math.max(item.quantity,pending);
    });
    const totals={};
    for(const item of cart.items)if(limits[item.handle])totals[item.handle]=(totals[item.handle]||0)+(Number(item.options_with_values?.[0]?.value)||1)*item.quantity;
    const item=cart.items.find(item=>limits[item.handle] && totals[item.handle]>limits[item.handle]);
    return item && {item,quantity:totals[item.handle]};
  };
  const updateLinks = () => {
    document.querySelectorAll('product-form[data-crc-pack-product]').forEach(form=>{
      const section=form.closest('.shopify-section');
      const text=section?.querySelector('[name="properties[Engraving Text]"],[name="properties[Engraving text]"]')?.value || '';
      form.querySelectorAll('[data-crc-quote-link]').forEach(link=>{
        const url=new URL(link.href);
        if(text)url.searchParams.set('engraving',text);else url.searchParams.delete('engraving');
        link.href=url.href;
      });
    });
  };
  document.addEventListener('input',updateLinks);
  document.addEventListener('on:variant:change',updateLinks);
  document.addEventListener('click',async event=>{
    if(event.target.closest('[data-crc-quote-link]')){updateLinks();return;}
    const checkout=event.target.closest('[name="checkout"],a[href="/checkout"]');
    if(!checkout || !document.querySelector('[data-crc-cart-guard]'))return;
    event.preventDefault();event.stopImmediatePropagation();
    try{
      const bulk=bulkItem(await readCart());
      if(bulk){location.assign(quoteUrl(bulk.item,bulk.quantity));return;}
      const form=checkout.closest('form');
      if(form){form.dataset.crcCheckoutVerified='true';form.requestSubmit(checkout);}
      else location.assign('/checkout');
    }catch(error){document.querySelector('[data-crc-cart-guard]').textContent=error.message;}
  },true);
  document.addEventListener('submit',async event=>{
    const form=event.target;
    if(!form.matches('form[action*="/cart"]') || !document.querySelector('[data-crc-cart-guard]'))return;
    if(form.dataset.crcCheckoutVerified==='true'){delete form.dataset.crcCheckoutVerified;return;}
    if(event.submitter?.name!=='checkout')return;
    event.preventDefault();event.stopImmediatePropagation();
    try{
      const bulk=bulkItem(await readCart());
      if(bulk)location.assign(quoteUrl(bulk.item,bulk.quantity));
      else {form.dataset.crcCheckoutVerified='true';form.requestSubmit(event.submitter);}
    }catch(error){document.querySelector('[data-crc-cart-guard]').textContent=error.message;}
  },true);
  document.addEventListener('submit',async event=>{
    const form=event.target.closest('product-form[data-crc-pack-product]');
    if(!form)return;
    if(event.target.dataset.crcPackChecked==='true'){delete event.target.dataset.crcPackChecked;return;}
    event.preventDefault();event.stopImmediatePropagation();
    const raw=form.closest('.shopify-section')?.querySelector('variant-picker script[type="application/json"]');
    if(!raw)return;
    const variant=JSON.parse(raw.textContent);
    const pack=Number(variant.option1)||1;
    const limit=Number(form.dataset.crcPackLimit);
    try{
      const cart=await readCart();
      const existing=cart.items.filter(i=>i.handle===form.dataset.crcPackProduct).reduce((n,i)=>n+(Number(i.options_with_values?.[0]?.value)||1)*i.quantity,0);
      if(existing+pack>limit){
        const url=new URL(form.querySelector('[data-crc-quote-link]').href);
        url.searchParams.set('quantity',String(existing+pack));location.assign(url.href);return;
      }
      event.target.dataset.crcPackChecked='true';event.target.requestSubmit(event.submitter);
    }catch(error){const box=form.querySelector('.js-form-error');if(box){box.hidden=false;box.textContent=error.message;}}
  },true);
})();
